import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Reveal from "@/components/common/Reveal";
import { SERVICES, PROCESS_STEPS } from "@/data/content";

export default function Services() {
  return (
    <>
      <section className="relative pt-20 md:pt-24 pb-6 md:pb-10 max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14" data-testid="services-hero">
        <div className="mono-label text-zinc-500">What We Do</div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] font-light mt-3 max-w-4xl">
          Design, build, <em className="not-italic text-[#BE1E2D] font-normal">maintain.</em>
        </h1>
        <p className="text-zinc-600 text-base md:text-lg max-w-xl mt-6 leading-relaxed">
          One team across the full project lifecycle — from the first borehole to long-term asset care.
        </p>
      </section>

      {/* SERVICES LIST */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 pb-16">
        <div className="flex flex-col gap-0 border-t border-zinc-200">
          {SERVICES.map((s, i) => (
            <Reveal key={s.code}>
              <div className="border-b border-zinc-200 py-10 md:py-14 grid lg:grid-cols-12 gap-6 group" data-testid={`service-row-${s.code}`}>
                <div className="lg:col-span-1">
                  <div className="mono-label text-[#BE1E2D]">{s.code}</div>
                </div>
                <div className="lg:col-span-5">
                  <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight group-hover:text-[#BE1E2D] transition-colors">
                    {s.title}
                  </h2>
                  <p className="text-zinc-500 text-base mt-3 italic font-display">{s.short}</p>
                </div>
                <div className="lg:col-span-3 text-zinc-700 leading-relaxed text-[15px]">
                  <p>{s.body}</p>
                </div>
                <div className="lg:col-span-3">
                  <div className="mono-label text-zinc-500 mb-3">Deliverables</div>
                  <ul className="space-y-1.5">
                    {s.deliverables.map((d) => (
                      <li key={d} className="flex items-start gap-3 text-sm">
                        <Check className="w-4 h-4 text-[#BE1E2D] mt-0.5 flex-shrink-0" />
                        <span>{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="bg-[#0A0A0A] text-white py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
          <Reveal>
            <div className="mono-label text-zinc-500">How We Work</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl mt-4 leading-[1.05] tracking-tight max-w-2xl">
              A four-stage process. One accountable team.
            </h2>
          </Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800 mt-10 md:mt-14">
            {PROCESS_STEPS.map((p, i) => (
              <Reveal key={p.code} delay={i * 0.08}>
                <div className="bg-[#0A0A0A] hover:bg-[#171717] transition-colors p-6 md:p-8 h-full min-h-[220px] flex flex-col justify-between">
                  <div>
                    <div className="font-display text-4xl md:text-5xl text-[#BE1E2D] font-light">{p.code}</div>
                    <div className="font-display text-2xl mt-4">{p.title}</div>
                  </div>
                  <p className="text-zinc-400 mt-4 leading-relaxed text-[15px]">{p.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 text-center bg-[#F9F9F8] border-t border-zinc-200">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="font-display text-3xl md:text-4xl leading-[1.05] tracking-tight">
            Have a specific scope in mind?
          </h2>
          <Link to="/contact" className="btn-primary mt-8 inline-flex" data-testid="services-cta">
            Request a Proposal <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </>
  );
}
